import { StyleSheetManager, ThemeProvider } from "styled-components";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import RoutesApp from "./routes";
import { FavoritesProvider } from "./context/FavoritesContext";
import GlobalStyles from "./styles/GlobalStyles";
import { theme } from "./styles/theme";

function App() {
  return (
    <StyleSheetManager disableCSSOMInjection>
      <ThemeProvider theme={theme}>
        <FavoritesProvider>
          <GlobalStyles />
          <ToastContainer
            autoClose={2600}
            position="top-right"
            theme="dark"
            toastStyle={{
              background: "#181818",
              color: "#f5f5f1",
              border: "1px solid rgba(255,255,255,0.08)",
            }}
          />
          <RoutesApp />
        </FavoritesProvider>
      </ThemeProvider>
    </StyleSheetManager>
  );
}

export default App;
